import { render } from "./ReelSceneEditor.vue?vue&type=template&id=0d58f94d&scoped=true&ts=true"
import script from "./ReelSceneEditor.vue?vue&type=script&lang=ts"
export * from "./ReelSceneEditor.vue?vue&type=script&lang=ts"

import "./ReelSceneEditor.vue?vue&type=style&index=0&id=0d58f94d&scoped=true&lang=css"

import exportComponent from "/var/jenkins_home/workspace/ecpv-pipeline/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0d58f94d"]])

export default __exports__